<template>
  <div class="wrapper" v-if="answer">
    <NavBar title="默契问答" />
    <div class="title-box">
      <div class="t-avatar">
        <img class="avatar top" mode="aspectFill" :src="answer.owner_avatar" />
        <img class="avatar" mode="aspectFill" :src="answer.joiner_avatar" />
      </div>
      <div class="title">{{ answer.owner_name }}：{{ answer.title }}</div>
      <div class="small">
        <label>答对：{{ answer.submit_data.right }} 题</label>
        <label>答错：{{ answer.submit_data.wrong }} 题</label>
      </div>
    </div>

    <div class="question-box">
      <div
        class="question"
        v-for="(a, index) in lists"
        :key="index"
      >
        <div class="desc">{{ index + 1 }}. {{ a.desc }}</div>
        <div class="options" v-if="a.type == 0 || a.type == 1 || a.type == 2">
          <div class="option" v-for="(item, cIndex) in a.options" :key="cIndex">
            <img
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/5c9458c6b1e97e44897643ebeb506e2f.png"
              v-if="item.right == 0 && item.checked == 1"
            />
            <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/a05fe5b9ba4a14f6ab5a652bcd97d149.png" v-else-if="item.right == 1" />
            <div
              class="letter"
              v-else
              :style="item.right==1 && show_answer != 3?'color:#00cf97':''"
            >
              {{ item.letter }}
            </div>
            <div class="div" v-if="show_answer == 3">{{ item.content }}</div>
            <div
              :style="(item.right==1 || (answer.temp == 3 && item.check == 1))?'color:#00cf97':(item.check==1?'color:#ff7070':'')"
              class="div"
              v-else
            >
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import { Toast } from "vant";
import { getToken } from "@/utils/common";
import NavBar from '@/components/navbar';

export default {
  components: {NavBar},
  data() {
    return {
      rid: "",
      show_answer: 0,
      answer: null,
      lists: [],
    };
  },
  methods: {
    getResult() {
      let self = this;
      let param = {
        rid: self.rid,
        access_token: getToken()
      };
      questionOnly.get(api.question.getResult, param).then(res => {
        if (res.sta == 0) {
          var r = res.data;
          var lists = r.lists;
          lists.map((n, i) => {
            let _data = r.submit_data.data[i];
            n.score_get = _data['score_get'] || 0
            let _score = r.temp == 2 ? r.avg_score : n.score;
            n.right = _score == n.score_get ? 1 : 0;
            if (n.options && n.options.length > 0) {
              if (_data.show_order) n.options = _data.show_order;
              // return;
              n.options.map((m, j) => {
                  // 选择题
                  if (r.temp != 3) {
                    m.check = 0;
                    m.letter = String.fromCharCode(64 + parseInt(j + 1));
                    if (_data["opt"] && _data["opt"].indexOf(j) != -1)
                      m.check = 1;
                  }
              });
            }
            let opt = _data["opt"];
            for (const i in opt) {
              let _letter = String.fromCharCode(64 + parseInt(opt[i]) + 1);
              n.your_answer += _letter;
            }
          });
          
          self.lists = lists;
          self.answer = r;
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  mounted() {
    this.rid = this.$route.query.rid
    this.getResult();
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.wrapper{
  background: linear-gradient(180deg, #0E5ED8 0%, #1B228E 100%);
  background-attachment: fixed;
  min-height: calc(100vh - 44px);
  height: auto;
  padding-top: 64px;
  box-sizing: border-box;
}
.title-box {
  position: relative;
  background-color: #fff;
  margin: rem(94) auto rem(30);
  padding: rem(60) rem(30) 0;
  line-height: 1.4;
  width: rem(690);
  box-sizing: border-box;
  border-radius: rem(8);
  text-align: center;
}
.t-avatar{
  position: absolute;
  left: 50%;
  top: rem(-64);
  transform: translate(-50%, 0);
  width: rem(242);
  height: rem(128);
}
.avatar{
  position: absolute;
  top: 0;
  right: 0;
  width: rem(120);
  height: rem(120);
  border-radius: 50%;
  border: rem(4) solid #fff;
}
.top{
  left: 0;
  right: auto;
  z-index: 2;
}

.title {
  font-size: rem(48);
  line-height: rem(72);
  color: #080E88;
  font-weight: bold;
  padding-top: rem(40);
}

.title-box .small {
  font-size: rem(26);
  color: #999;
  padding: rem(40) 0;
  line-height: rem(39);
}

.title-box .small label {
  margin-right: rem(60);
}

.question-box{
  overflow: hidden;
}
.question {
  background-color: #fff;
  width: rem(690);
  box-sizing: border-box;
  border-radius: rem(8);
  margin: rem(30) auto;
  padding: 0 rem(30) rem(30);
}

.desc {
  padding: rem(40) 0;
  font-size: rem(30);
}

.option {
  display: flex;
  display: -webkit-flex;
  font-size: rem(30);
  align-items: center;
  margin-bottom: rem(40);
}

.option:last-child {
  margin-bottom: 0;
}

.option img,
.letter {
  width: rem(36);
  height: rem(36);
  margin-right: rem(20);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.option .view {
  flex: 1
}

.grey {
  color: #999;
  padding-right: rem(10);
}
view.grey{
  padding-top: rem(10);
}

.answer {
  font-size: rem(30);
  /* padding-top: 40rem(); */
}

.answer:last-child {
  padding-top: rem(40);
  padding-bottom: rem(40);
}

.info-box {
  background: #fff;
  padding: 0 rem(30);
  margin-bottom: rem(20);
}

.info-box .top {
  border-bottom: rem(1) solid #eee;
  font-size: rem(30);
  padding: rem(30) 0;
}

.info-box .bottom {
  font-size: rem(28);
  padding: rem(24) 0;
  line-height: 1.8;
}

.blank-text{
  padding: 0 rem(20);
}


.text-red{
  color: #ff5c5c !important;
  padding: 0 rem(20);
}

.question-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: rem(1) solid #eee;
  height: rem(100);
}

</style>



// WEBPACK FOOTER //
// src/pages/answer/answerTacit.vue